// extracted by mini-css-extract-plugin
export default {"sidebarTitleWrapper":"SidebarSectionTitle_sidebarTitleWrapper__D5+Q1","title":"SidebarSectionTitle_title__DOCVv"};